import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { articlesAPI, newsletterAPI } from '../services/api';

function ArticleDetail() {
  const { articleId } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeImage, setActiveImage] = useState('');
  const [recentArticles, setRecentArticles] = useState([]);
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState({ text: '', type: '' });
  const [newsletterLoading, setNewsletterLoading] = useState(false);

  // Fallback data in case the PHP API / MySQL database is not ready
  const fallbackArticles = [
    {
      id: 1,
      program_id: 'international-mobility',
      title: 'Erasmus+ Intercultural Youth Exchange in Siedlce, Poland',
      excerpt: 'A detailed look at the 2024 youth exchange connecting 30 young leaders to discuss environmental issues and sustainability.',
      content: "The 'United for Climate' youth exchange, organized by the Europe Foundation for International Solidarity (EFIS), took place in Siedlce, Poland. For two weeks, 30 participants from 8 different European countries gathered to exchange ideas on environmental activism, green entrepreneurship, and sustainable living.\n\nThroughout the program, participants engaged in interactive workshops, role-playing simulations, and community clean-up initiatives. They also had the opportunity to design local eco-campaigns, which they later presented to the local municipality.\n\nThis project was supported by the Erasmus+ Programme of the European Union, facilitating cross-border cooperation and reinforcing values of global citizenship, environmental awareness, and mutual respect among the participants. The feedback was extremely positive, with participants noting a significant increase in their leadership and environmental planning skills.",
      author: 'Thomas Novak',
      image_url: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80',
      image_urls: [
        'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80',
        'https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?auto=format&fit=crop&w=800&q=80',
        'https://images.unsplash.com/photo-1515187029135-18ee286d815b?auto=format&fit=crop&w=800&q=80'
      ],
      published_at: '2024-05-15 10:00:00'
    },
    {
      id: 2,
      program_id: 'international-mobility',
      title: 'European Solidarity Corps: Volunteering Journey',
      excerpt: 'Discover how ESC volunteers from across Europe are contributing to local communities in Siedlce and Krakow.',
      content: "The European Solidarity Corps (ESC) provides young people with the opportunity to volunteer in projects that benefit communities. At EFIS, we host volunteers who help in schools, organize community activities, and support youth centres. \n\nThis article highlights the journey of Elena from Spain and Jan from Germany as they navigate their 10-month volunteering service, learning Polish, teaching languages, and hosting workshops. Through their presence, they inspire local youth to look beyond borders and engage in international programs.",
      author: 'Sofia Rodriguez',
      image_url: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=800&q=80',
      image_urls: [
        'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=800&q=80',
        'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=800&q=80'
      ],
      published_at: '2024-04-10 14:30:00'
    },
    {
      id: 3,
      program_id: 'global-citizenship',
      title: 'Raising Awareness for Human Rights and Peace',
      excerpt: 'Our digital campaign reaches thousands, advocating for human dignity, self-determination, and the rule of law.',
      content: "In celebration of Human Rights Day, EFIS launched an online and offline awareness campaign. Through social media stories, infographics, and public debates, the campaign aimed to educate youth about the Universal Declaration of Human Rights and the role of global citizenship.\n\nOver 50 volunteers contributed, creating educational content in 5 languages to reach a broader audience. Workshops were held in Siedlce schools to discuss the historical foundations of peace, respect, and intercultural coexistence, breaking down prejudices and fostering mutual understanding.",
      author: 'Anna Kowalski',
      image_url: 'https://images.unsplash.com/photo-1469571486090-7d99c11d50c7?auto=format&fit=crop&w=800&q=80',
      image_urls: [
        'https://images.unsplash.com/photo-1469571486090-7d99c11d50c7?auto=format&fit=crop&w=800&q=80',
        'https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=800&q=80'
      ],
      published_at: '2024-03-20 09:00:00'
    },
    {
      id: 4,
      program_id: 'cooperation-development',
      title: 'Supporting Educational Infrastructure in Kenya',
      excerpt: 'Collaborating with local schools in rural Kenya to build clean water access and provide learning supplies.',
      content: "EFIS collaborated with Kenyan development organizations to implement the 'Volunteering for Education' project. The initiative focused on supporting primary schools by constructing clean water installations, setting up digital learning rooms, and supplying books.\n\nThis project forms part of our strategic expansion towards the UN Sustainable Development Goals (SDGs), addressing education and inequality. Our team organized training sessions for local educators to integrate digital tools in their daily pedagogy, ensuring long-term project sustainability and local empowerment.",
      author: 'Dr. Michael Chen',
      image_url: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=800&q=80',
      image_urls: [
        'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=800&q=80',
        'https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=800&q=80'
      ],
      published_at: '2024-02-15 11:15:00'
    },
    {
      id: 5,
      program_id: 'youth-empowerment',
      title: 'Youth Leadership Summit 2024: Designing Tomorrow',
      excerpt: 'Building leadership, non-formal education, and active citizenship skills in Krakow for European youth leaders.',
      content: "The Youth Leadership Summit gathered 80 young changemakers in Krakow, Poland. The weekend was packed with workshops on conflict resolution, project management, and public speaking.\n\nLed by expert trainers, participants drafted action plans to address civic engagement and youth representation in local government across Europe. They learned about democratic values, active participation, and how to create positive impact in their local communities.",
      author: 'Dr. Michael Chen',
      image_url: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=800&q=80',
      image_urls: [
        'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=800&q=80',
        'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=800&q=80'
      ],
      published_at: '2024-01-25 16:00:00'
    }
  ];

  const getProgramTitle = (id) => {
    const titles = {
      'international-mobility': 'International Mobility Programs',
      'global-citizenship': 'Promotion of Global Citizenship',
      'cooperation-development': 'International Cooperation & Development',
      'youth-empowerment': 'Youth Empowerment & Capacity Building'
    };
    return titles[id] || 'Program Activity';
  };

  useEffect(() => {
    fetchArticle();
  }, [articleId]);

  const fetchArticle = async () => {
    try {
      setLoading(true);
      const response = await articlesAPI.getById(articleId);
      if (response.data && response.data.success && response.data.data) {
        const data = response.data.data;
        setArticle(data);
        setActiveImage(data.image_url);
        fetchRecentArticles(data.program_id);
      } else {
        // Fallback
        const art = fallbackArticles.find(a => a.id === parseInt(articleId));
        if (art) {
          setArticle(art);
          setActiveImage(art.image_url);
          fetchRecentArticles(art.program_id);
        }
      }
    } catch (error) {
      console.warn('API error, using local fallback data:', error.message);
      const art = fallbackArticles.find(a => a.id === parseInt(articleId));
      if (art) {
        setArticle(art);
        setActiveImage(art.image_url);
        fetchRecentArticles(art.program_id);
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchRecentArticles = (programId) => {
    const recents = fallbackArticles
      .filter(a => a.program_id === programId && a.id !== parseInt(articleId))
      .slice(0, 3);
    setRecentArticles(recents);
  };

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!newsletterEmail) return;
    try {
      setNewsletterLoading(true);
      setNewsletterStatus({ text: '', type: '' });
      const response = await newsletterAPI.subscribe(newsletterEmail);
      if (response.data.success) {
        setNewsletterStatus({ text: 'Thank you for subscribing!', type: 'success' });
        setNewsletterEmail('');
      } else {
        setNewsletterStatus({ text: response.data.message || 'Error subscribing', type: 'error' });
      }
    } catch (err) {
      console.error(err);
      setNewsletterStatus({ text: 'Connection error', type: 'error' });
    } finally {
      setNewsletterLoading(false);
      setTimeout(() => setNewsletterStatus({ text: '', type: '' }), 5000);
    }
  };

  if (loading) {
    return (
      <main>
        <div className="slider-area2">
          <div className="slider-height2 d-flex align-items-center">
            <div className="container">
              <div className="row">
                <div className="col-xl-12">
                  <div className="hero-cap hero-cap2 pt-20 text-center">
                    <h2>Loading Article Details...</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }

  if (!article) {
    return (
      <main>
        <div className="slider-area2">
          <div className="slider-height2 d-flex align-items-center">
            <div className="container">
              <div className="row">
                <div className="col-xl-12">
                  <div className="hero-cap hero-cap2 pt-20 text-center">
                    <h2>Article Not Found</h2>
                    <Link to="/programs" className="btn" style={{marginTop: '20px'}}>Back to Programs</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }

  // Parse image list
  const allImages = Array.isArray(article.image_urls) 
    ? article.image_urls 
    : (typeof article.image_urls === 'string' ? JSON.parse(article.image_urls) : [article.image_url]);

  return (
    <main>
      {/* Hero Start */}
      <div className="slider-area2">
        <div className="slider-height2 d-flex align-items-center">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="hero-cap hero-cap2 pt-70 text-center">
                  <h2>{article.title}</h2>
                  <p style={{color: 'rgba(255,255,255,0.8)', marginTop: '10px'}}>
                    {getProgramTitle(article.program_id)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <section className="blog_area section-padding" className="about-low-area section-padding30" >
        <div className="container">
          <div className="row">
            {/* Left Column */}
            <div className="col-lg-8 mb-5 mb-lg-0">
              <div className="blog_left_sidebar">
                <article className="blog_item">
                  {/* Image Gallery / Display */}
                  <div className="blog_item_img" style={{borderRadius: '12px', overflow: 'hidden', boxShadow: '0 5px 15px rgba(0,0,0,0.05)'}}>
                    <img 
                      className="card-img rounded-0" 
                      src={activeImage || article.image_url} 
                      alt={article.title} 
                      style={{height: '450px', objectFit: 'cover', width: '100%'}}
                    />
                    <div className="blog_item_date" style={{ backgroundColor: 'var(--primary-blue)' }}>
                      <h3>{new Date(article.published_at).getDate()}</h3>
                      <p>{new Date(article.published_at).toLocaleString('default', { month: 'short' })}</p>
                    </div>
                  </div>

                  {/* Thumbnail Carousel */}
                  {allImages.length > 1 && (
                    <div className="d-flex gap-2 mt-3 flex-wrap">
                      {allImages.map((img, idx) => (
                        <div 
                          key={idx} 
                          onClick={() => setActiveImage(img)}
                          style={{
                            width: '80px', 
                            height: '60px', 
                            cursor: 'pointer', 
                            border: activeImage === img ? '2px solid var(--accent-red)' : '2px solid transparent', 
                            borderRadius: '4px', 
                            overflow: 'hidden',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                            opacity: activeImage === img ? 1 : 0.7
                          }}
                        >
                          <img src={img} alt="" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="blog_details" style={{paddingTop: '30px'}}>
                    <h2 className="blog-head" style={{color: '#1e293b', fontWeight: '700', fontSize: '26px'}}>{article.title}</h2>
                    <p style={{color: 'var(--accent-red)', fontWeight: '600', marginBottom: '20px', fontSize: '14px'}}>
                      ✍️ Written by {article.author} • Category: {getProgramTitle(article.program_id)}
                    </p>
                    
                    {/* Render paragraphs nicely */}
                    {article.content.split('\n\n').map((para, i) => (
                      <p key={i} style={{lineHeight: '1.8', color: '#4b5563', fontSize: '15.5px', marginBottom: '20px'}}>
                        {para}
                      </p>
                    ))}

                    <div style={{marginTop: '40px', display: 'flex', gap: '15px'}}>
                      <Link to={`/programs/${article.program_id}`} className="btn">
                        ← Go to Category
                      </Link>
                      <Link to="/programs" className="btn white-btn">
                        All Programs
                      </Link>
                    </div>
                  </div>
                </article>
              </div>
            </div>

            {/* Sidebar Column */}
            <div className="col-lg-4">
              <div className="blog_right_sidebar" style={{padding: '30px', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0'}}>
                
                {/* Author Profile widget */}
                <aside className="single_sidebar_widget" style={{marginBottom: '30px', textAlign: 'center'}}>
                  <h4 style={{fontWeight: '700', color: 'var(--primary-blue)', marginBottom: '15px'}}>Author</h4>
                  <div style={{width: '90px', height: '90px', borderRadius: '50%', background: 'linear-gradient(135deg, var(--primary-blue) 0%, var(--accent-red) 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px'}}>
                    <span style={{fontSize: '40px', color: 'white'}}>✍️</span>
                  </div>
                  <h5 style={{fontWeight: '600', color: '#1e293b'}}>{article.author}</h5>
                  <p style={{fontSize: '13px', color: '#64748b', marginTop: '5px'}}>EFIS Communications Team</p>
                </aside>

                {/* Recent Articles widget */}
                {recentArticles.length > 0 && (
                  <aside className="single_sidebar_widget popular_post_widget" style={{marginBottom: '30px'}}>
                    <h3 className="widget_title" style={{color: '#1e293b', borderBottom: '2px solid var(--accent-red)', paddingBottom: '10px', marginBottom: '20px'}}>Related Articles</h3>
                    {recentArticles.map((art) => (
                      <div key={art.id} className="media post_item mb-3 d-flex align-items-center">
                        <img 
                          src={art.image_url} 
                          alt="" 
                          style={{width: '70px', height: '55px', borderRadius: '6px', objectFit: 'cover', marginRight: '15px'}} 
                        />
                        <div className="media-body">
                          <Link to={`/articles/${art.id}`}>
                            <h4 style={{color: '#1e293b', fontSize: '14px', fontWeight: '700', margin: '0', height: '38px', overflow: 'hidden'}}>{art.title}</h4>
                          </Link>
                          <span style={{fontSize: '11px', color: '#64748b'}}>
                            {new Date(art.published_at).toLocaleDateString()}
                          </span>
                        </div>
                      </div>
                    ))}
                  </aside>
                )}

                {/* Newsletter Widget */}
                <aside className="single_sidebar_widget newsletter_widget">
                  <h4 style={{fontWeight: '700', color: 'var(--primary-blue)', marginBottom: '15px'}}>EFIS Newsletter</h4>
                  <p style={{fontSize: '13px', color: '#64748b', marginBottom: '15px'}}>Subscribe to stay updated on our international projects and calls for volunteers.</p>
                  <form onSubmit={handleNewsletterSubmit}>
                    <div className="form-group" style={{marginBottom: '15px'}}>
                      <input 
                        type="email" 
                        className="form-control" 
                        placeholder="Enter email" 
                        value={newsletterEmail}
                        onChange={(e) => setNewsletterEmail(e.target.value)}
                        required 
                        style={{padding: '12px', borderRadius: '6px', border: '1px solid #ddd'}}
                      />
                    </div>
                    <button className="btn w-100" type="submit" style={{padding: '12px'}} disabled={newsletterLoading}>
                      {newsletterLoading ? 'Subscribing...' : 'Subscribe'}
                    </button>
                  </form>
                  {newsletterStatus.text && (
                    <div className="alert mt-3" style={{
                      fontSize: '13px',
                      padding: '10px',
                      background: newsletterStatus.type === 'success' ? '#d4edda' : '#f8d7da',
                      color: newsletterStatus.type === 'success' ? '#155724' : '#721c24',
                      border: `1px solid ${newsletterStatus.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                      borderRadius: '6px'
                    }}>
                      {newsletterStatus.text}
                    </div>
                  )}
                </aside>

              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default ArticleDetail;
